// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AuthModal_overlay__WjGWt {
  position: fixed;
  inset: 0;
  z-index: 50;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  overflow-y: auto;
  overscroll-behavior: contain;
}

.AuthModal_backdrop__nCSzQ {
  position: absolute;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.5);
}

.AuthModal_modal__2mBhy {
  position: relative;
  background-color: #ffffff;
  border-radius: 16px;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  width: 100%;
  max-width: 448px;
  max-height: calc(100vh - 32px);
  max-height: calc(100dvh - 32px);
  overflow: hidden;
}

.AuthModal_closeBtn__uDTXq {
  position: absolute;
  top: 16px;
  right: 16px;
  width: 44px;
  height: 44px;
  padding: 10px;
  display: grid;
  place-items: center;
  background: transparent;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  transition: background-color 0.2s ease;
  z-index: 2;
}
.AuthModal_closeBtn__uDTXq:hover {
  background-color: #f3f4f6;
}
.AuthModal_closeBtn__uDTXq:focus-visible {
  outline: 3px solid rgba(37, 99, 235, 0.3);
  outline-offset: 2px;
}
.AuthModal_closeBtn__uDTXq svg {
  font-size: 24px;
  color: #374151;
}

.AuthModal_content__X960c {
  padding: 32px;
  width: 100%;
  max-height: calc(100vh - 32px);
  max-height: calc(100dvh - 32px);
  overflow-y: auto;
  overscroll-behavior: contain;
  scrollbar-gutter: stable;
  box-sizing: border-box;
}

.AuthModal_title__EJUoo {
  font-size: 1.875rem;
  font-weight: 700;
  color: #111827;
  margin-bottom: 24px;
  padding-right: 40px;
}

.AuthModal_infoBanner__fpQod {
  display: flex;
  align-items: center;
  gap: 12px;
  background-color: #eff6ff;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 24px;
}
.AuthModal_infoBanner__fpQod p {
  font-size: 14px;
  color: #374151;
  margin: 0;
  line-height: 1.4;
}

.AuthModal_infoIcon__T6bX- {
  color: #2563eb;
  font-size: 20px !important;
  flex-shrink: 0;
}

.AuthModal_tabToggle__j5WQ5 {
  display: flex;
  gap: 8px;
  margin-bottom: 24px;
}

.AuthModal_tabBtn__4KAnq {
  flex: 1 1;
  padding: 12px 24px;
  border-radius: 50px;
  font-size: 14px;
  font-weight: 600;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease;
  background-color: #f3f4f6;
  color: #374151;
}
.AuthModal_tabBtn__4KAnq:hover {
  background-color: #e5e7eb;
}
.AuthModal_tabBtn__4KAnq.AuthModal_active__pvKsS {
  background-color: #111827;
  color: #ffffff;
}

.AuthModal_socialButtons__H\\+Z\\+e {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 24px;
}

.AuthModal_googleBtn__nB42O,
.AuthModal_facebookBtn__Yy6gY,
.AuthModal_appleBtn__xyVCg {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  height: 48px;
  border-radius: 50px;
  font-size: 14px;
  font-weight: 600;
  border: none;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.AuthModal_googleBtn__nB42O {
  background-color: #4285f4;
  color: #ffffff;
}
.AuthModal_googleBtn__nB42O:hover {
  background-color: #3367d6;
}

.AuthModal_facebookBtn__Yy6gY {
  background-color: #1877f2;
  color: #ffffff;
}
.AuthModal_facebookBtn__Yy6gY:hover {
  background-color: #166fe5;
}

.AuthModal_appleBtn__xyVCg {
  background-color: #000000;
  color: #ffffff;
}
.AuthModal_appleBtn__xyVCg:hover {
  background-color: #1a1a1a;
}

.AuthModal_socialIcon__lM3Xw {
  width: 20px;
  height: 20px;
}

.AuthModal_divider__98Mac {
  display: flex;
  align-items: center;
  gap: 16px;
  margin: 24px 0;
}
.AuthModal_divider__98Mac::before, .AuthModal_divider__98Mac::after {
  content: "";
  flex: 1 1;
  height: 1px;
  background-color: #d1d5db;
}
.AuthModal_divider__98Mac span {
  font-size: 14px;
  color: #6b7280;
}

.AuthModal_formGroup__dHQlU {
  margin-bottom: 16px;
}

.AuthModal_formRow__iRhqb {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}
.AuthModal_formRow__iRhqb .AuthModal_formGroup__dHQlU {
  margin-bottom: 16px;
}

.AuthModal_label__1tq0v {
  display: block;
  font-size: 14px;
  font-weight: 600;
  color: #111827;
  margin-bottom: 8px;
}

.AuthModal_input__pRkh1 {
  width: 100%;
  height: 48px;
  padding: 0 16px;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  font-size: 16px;
  outline: none;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
  box-sizing: border-box;
}
.AuthModal_input__pRkh1::placeholder {
  color: #9ca3af;
}
.AuthModal_input__pRkh1:focus {
  border-color: #2563eb;
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);
}
.AuthModal_input__pRkh1:disabled {
  background-color: #f3f4f6;
  cursor: not-allowed;
}

.AuthModal_inputError__N-670 {
  border-color: #dc2626;
}
.AuthModal_inputError__N-670:focus {
  border-color: #dc2626;
  box-shadow: 0 0 0 3px rgba(220, 38, 38, 0.1);
}

.AuthModal_errorText__yIyXz {
  display: block;
  font-size: 12px;
  color: #dc2626;
  margin-top: 4px;
}

.AuthModal_errorBanner__GttOL {
  background-color: #fef2f2;
  border: 1px solid #fecaca;
  border-radius: 8px;
  padding: 12px 16px;
  margin-bottom: 16px;
  color: #dc2626;
  font-size: 14px;
}

.AuthModal_passwordWrapper__6Fe8g {
  position: relative;
}
.AuthModal_passwordWrapper__6Fe8g .AuthModal_input__pRkh1 {
  padding-right: 52px;
}

.AuthModal_passwordToggle__4q\\+vo {
  position: absolute;
  right: 4px;
  top: 50%;
  width: 44px;
  height: 44px;
  transform: translateY(-50%);
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  color: #6b7280;
  display: flex;
  align-items: center;
  justify-content: center;
}
.AuthModal_passwordToggle__4q\\+vo:hover {
  color: #374151;
}
.AuthModal_passwordToggle__4q\\+vo:focus-visible {
  outline: 2px solid #2563eb;
  outline-offset: 2px;
  border-radius: 6px;
}
.AuthModal_passwordToggle__4q\\+vo svg {
  font-size: 20px;
}

.AuthModal_forgotPassword__sInqM {
  display: inline-block;
  font-size: 14px;
  color: #2563eb;
  text-decoration: none;
  margin-bottom: 16px;
}
.AuthModal_forgotPassword__sInqM:hover {
  text-decoration: underline;
}

.AuthModal_primaryBtn__H320r {
  width: 100%;
  height: 48px;
  background-color: #2563eb;
  color: #ffffff;
  border: none;
  border-radius: 50px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s ease;
  margin-bottom: 16px;
}
.AuthModal_primaryBtn__H320r:hover {
  background-color: #1d4ed8;
}

.AuthModal_terms__pymqX {
  font-size: 12px;
  color: #4b5563;
  text-align: center;
  line-height: 1.5;
}
.AuthModal_terms__pymqX a {
  color: #2563eb;
  text-decoration: underline;
}

.AuthModal_buttonGroup__XCfDU {
  display: flex;
  gap: 8px;
}

.AuthModal_outlineBtn__tpyA1 {
  flex: 1 1;
  height: 48px;
  background-color: transparent;
  color: #374151;
  border: 1px solid #d1d5db;
  border-radius: 50px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s ease;
}
.AuthModal_outlineBtn__tpyA1:hover {
  background-color: #f9fafb;
}

.AuthModal_outlineBtnFull__F60Cj {
  width: 100%;
  height: 48px;
  background-color: transparent;
  color: #374151;
  border: 1px solid #d1d5db;
  border-radius: 50px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s ease;
}
.AuthModal_outlineBtnFull__F60Cj:hover {
  background-color: #f9fafb;
}

.AuthModal_addressInputWrapper__YL42y {
  position: relative;
}

.AuthModal_addressIcon__VD1pq {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: #9ca3af;
  font-size: 20px !important;
  z-index: 1;
  pointer-events: none;
}

.AuthModal_addressInput__XIpB6 {
  padding-left: 40px !important;
  padding-right: 40px !important;
}

.AuthModal_addressSecondary__ejOeN {
  margin-top: 8px;
}

.AuthModal_addressLoader__q8U7s {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
}

.AuthModal_addressSuggestions__yiwnj {
  position: absolute;
  left: 0;
  right: 0;
  top: 100%;
  margin-top: 4px;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);
  z-index: 100;
  max-height: 200px;
  overflow-y: auto;
  list-style: none;
  padding: 0;
  margin-bottom: 0;
}

.AuthModal_addressSuggestionItem__nobp9 {
  padding: 10px 14px;
  cursor: pointer;
  border-bottom: 1px solid #f3f4f6;
  color: #374151;
  font-size: 14px;
  transition: background 0.15s;
  display: flex;
  align-items: flex-start;
}
.AuthModal_addressSuggestionItem__nobp9:last-child {
  border-bottom: none;
}
.AuthModal_addressSuggestionItem__nobp9:hover {
  background: #f3f4f6;
}

.AuthModal_suggestionContent__eIu-r {
  display: flex;
  flex-direction: column;
}

.AuthModal_suggestionPrimary__h0l1- {
  font-weight: 700;
  color: #111827;
}

.AuthModal_suggestionSecondary__Q232s {
  font-size: 13px;
  color: #6b7280;
}

.AuthModal_successText__zyovj {
  display: block;
  font-size: 12px;
  color: #16a34a;
  margin-top: 4px;
}

.AuthModal_merchantLink__J4qdO {
  text-align: center;
  font-size: 14px;
  color: #4b5563;
  margin: 16px 0 0 0;
}
.AuthModal_merchantLink__J4qdO a {
  color: #111827;
  font-weight: 600;
  text-decoration: none;
}
.AuthModal_merchantLink__J4qdO a:hover {
  text-decoration: underline;
}

.AuthModal_recaptchaWrap__X6Jw1 {
  overflow: hidden;
}

@media (max-width: 480px) {
  .AuthModal_overlay__WjGWt {
    padding: 12px;
  }
  .AuthModal_modal__2mBhy {
    max-height: calc(100vh - 24px);
    max-height: calc(100dvh - 24px);
    border-radius: 14px;
    scrollbar-gutter: auto;
  }
  .AuthModal_content__X960c {
    padding: 24px 18px 20px;
    max-height: calc(100vh - 24px);
    max-height: calc(100dvh - 24px);
    scrollbar-gutter: auto;
  }
  .AuthModal_closeBtn__uDTXq {
    top: 10px;
    right: 10px;
  }
  .AuthModal_title__EJUoo {
    font-size: 1.55rem;
    line-height: 1.15;
    margin-bottom: 18px;
  }
  .AuthModal_infoBanner__fpQod {
    padding: 12px;
    margin-bottom: 18px;
  }
  .AuthModal_tabToggle__j5WQ5,
  .AuthModal_socialButtons__H\\+Z\\+e {
    margin-bottom: 18px;
  }
  .AuthModal_divider__98Mac {
    margin: 18px 0;
  }
}
@media (max-width: 380px) {
  .AuthModal_formRow__iRhqb {
    grid-template-columns: 1fr;
    gap: 0;
  }
  .AuthModal_recaptchaWrap__X6Jw1 > div {
    width: 108.7%;
    margin-bottom: -5px;
    transform: scale(0.92);
    transform-origin: top left;
  }
}
@media (max-width: 340px) {
  .AuthModal_recaptchaWrap__X6Jw1 > div {
    width: 125%;
    margin-bottom: -15px;
    transform: scale(0.8);
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/LandingPage/AuthModal/AuthModal.module.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,QAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,gBAAA;EACA,4BAAA;AACF;;AAEA;EACE,kBAAA;EACA,QAAA;EACA,oCAAA;AACF;;AAEA;EACE,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,iDAAA;EACA,WAAA;EACA,gBAAA;EACA,8BAAA;EACA,+BAAA;EACA,gBAAA;AACF;;AAEA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,sCAAA;EACA,UAAA;AACF;AACE;EACE,yBAAA;AACJ;AAEE;EACE,yCAAA;EACA,mBAAA;AAAJ;AAGE;EACE,eAAA;EACA,cAAA;AADJ;;AAKA;EACE,aAAA;EACA,WAAA;EACA,8BAAA;EACA,+BAAA;EACA,gBAAA;EACA,4BAAA;EACA,wBAAA;EACA,sBAAA;AAFF;;AAKA;EACE,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,mBAAA;AAFF;;AAKA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;AAFF;AAIE;EACE,eAAA;EACA,cAAA;EACA,SAAA;EACA,gBAAA;AAFJ;;AAMA;EACE,cAAA;EACA,0BAAA;EACA,cAAA;AAHF;;AAMA;EACE,aAAA;EACA,QAAA;EACA,mBAAA;AAHF;;AAMA;EACE,SAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,yBAAA;EACA,yBAAA;EACA,cAAA;AAHF;AAKE;EACE,yBAAA;AAHJ;AAME;EACE,yBAAA;EACA,cAAA;AAJJ;;AAQA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,mBAAA;AALF;;AAQA;;;EAGE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,sCAAA;AALF;;AAQA;EACE,yBAAA;EACA,cAAA;AALF;AAOE;EACE,yBAAA;AALJ;;AASA;EACE,yBAAA;EACA,cAAA;AANF;AAQE;EACE,yBAAA;AANJ;;AAUA;EACE,yBAAA;EACA,cAAA;AAPF;AASE;EACE,yBAAA;AAPJ;;AAWA;EACE,WAAA;EACA,YAAA;AARF;;AAWA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,cAAA;AARF;AAUE;EAEE,WAAA;EACA,SAAA;EACA,WAAA;EACA,yBAAA;AATJ;AAYE;EACE,eAAA;EACA,cAAA;AAVJ;;AAcA;EACE,mBAAA;AAXF;;AAcA;EACE,aAAA;EACA,8BAAA;EACA,SAAA;AAXF;AAaE;EACE,mBAAA;AAXJ;;AAeA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AAZF;;AAeA;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;EACA,wDAAA;EACA,sBAAA;AAZF;AAcE;EACE,cAAA;AAZJ;AAeE;EACE,qBAAA;EACA,4CAAA;AAbJ;AAgBE;EACE,yBAAA;EACA,mBAAA;AAdJ;;AAkBA;EACE,qBAAA;AAfF;AAiBE;EACE,qBAAA;EACA,4CAAA;AAfJ;;AAmBA;EACE,cAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;AAhBF;;AAmBA;EACE,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;AAhBF;;AAmBA;EACE,kBAAA;AAhBF;AAkBE;EACE,mBAAA;AAhBJ;;AAoBA;EACE,kBAAA;EACA,UAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,2BAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,UAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAjBF;AAmBE;EACE,cAAA;AAjBJ;AAoBE;EACE,0BAAA;EACA,mBAAA;EACA,kBAAA;AAlBJ;AAqBE;EACE,eAAA;AAnBJ;;AAuBA;EACE,qBAAA;EACA,eAAA;EACA,cAAA;EACA,qBAAA;EACA,mBAAA;AApBF;AAsBE;EACE,0BAAA;AApBJ;;AAwBA;EACE,WAAA;EACA,YAAA;EACA,yBAAA;EACA,cAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,sCAAA;EACA,mBAAA;AArBF;AAuBE;EACE,yBAAA;AArBJ;;AAyBA;EACE,eAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;AAtBF;AAwBE;EACE,cAAA;EACA,0BAAA;AAtBJ;;AA0BA;EACE,aAAA;EACA,QAAA;AAvBF;;AA0BA;EACE,SAAA;EACA,YAAA;EACA,6BAAA;EACA,cAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,sCAAA;AAvBF;AAyBE;EACE,yBAAA;AAvBJ;;AA2BA;EACE,WAAA;EACA,YAAA;EACA,6BAAA;EACA,cAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,sCAAA;AAxBF;AA0BE;EACE,yBAAA;AAxBJ;;AA6BA;EACE,kBAAA;AA1BF;;AA6BA;EACE,kBAAA;EACA,UAAA;EACA,QAAA;EACA,2BAAA;EACA,cAAA;EACA,0BAAA;EACA,UAAA;EACA,oBAAA;AA1BF;;AA6BA;EACE,6BAAA;EACA,8BAAA;AA1BF;;AA6BA;EACE,eAAA;AA1BF;;AA6BA;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,2BAAA;AA1BF;;AA6BA;EACE,kBAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,eAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,2CAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,UAAA;EACA,gBAAA;AA1BF;;AA6BA;EACE,kBAAA;EACA,eAAA;EACA,gCAAA;EACA,cAAA;EACA,eAAA;EACA,4BAAA;EACA,aAAA;EACA,uBAAA;AA1BF;AA4BE;EACE,mBAAA;AA1BJ;AA6BE;EACE,mBAAA;AA3BJ;;AA+BA;EACE,aAAA;EACA,sBAAA;AA5BF;;AA+BA;EACE,gBAAA;EACA,cAAA;AA5BF;;AA+BA;EACE,eAAA;EACA,cAAA;AA5BF;;AA+BA;EACE,cAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;AA5BF;;AA+BA;EACE,kBAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;AA5BF;AA8BE;EACE,cAAA;EACA,gBAAA;EACA,qBAAA;AA5BJ;AA8BI;EACE,0BAAA;AA5BN;;AAiCA;EACE,gBAAA;AA9BF;;AAiCA;EACE;IACE,aAAA;EA9BF;EAiCA;IACE,8BAAA;IACA,+BAAA;IACA,mBAAA;IACA,sBAAA;EA/BF;EAkCA;IACE,uBAAA;IACA,8BAAA;IACA,+BAAA;IACA,sBAAA;EAhCF;EAmCA;IACE,SAAA;IACA,WAAA;EAjCF;EAoCA;IACE,kBAAA;IACA,iBAAA;IACA,mBAAA;EAlCF;EAqCA;IACE,aAAA;IACA,mBAAA;EAnCF;EAsCA;;IAEE,mBAAA;EApCF;EAuCA;IACE,cAAA;EArCF;AACF;AAwCA;EACE;IACE,0BAAA;IACA,MAAA;EAtCF;EAyCA;IACE,aAAA;IACA,mBAAA;IACA,sBAAA;IACA,0BAAA;EAvCF;AACF;AA0CA;EACE;IACE,WAAA;IACA,oBAAA;IACA,qBAAA;EAxCF;AACF","sourcesContent":[".overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 50;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 16px;\n  overflow-y: auto;\n  overscroll-behavior: contain;\n}\n\n.backdrop {\n  position: absolute;\n  inset: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n}\n\n.modal {\n  position: relative;\n  background-color: #ffffff;\n  border-radius: 16px;\n  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);\n  width: 100%;\n  max-width: 448px;\n  max-height: calc(100vh - 32px);\n  max-height: calc(100dvh - 32px);\n  overflow: hidden;\n}\n\n.closeBtn {\n  position: absolute;\n  top: 16px;\n  right: 16px;\n  width: 44px;\n  height: 44px;\n  padding: 10px;\n  display: grid;\n  place-items: center;\n  background: transparent;\n  border: none;\n  border-radius: 50%;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n  z-index: 2;\n\n  &:hover {\n    background-color: #f3f4f6;\n  }\n\n  &:focus-visible {\n    outline: 3px solid rgba(37, 99, 235, 0.3);\n    outline-offset: 2px;\n  }\n\n  svg {\n    font-size: 24px;\n    color: #374151;\n  }\n}\n\n.content {\n  padding: 32px;\n  width: 100%;\n  max-height: calc(100vh - 32px);\n  max-height: calc(100dvh - 32px);\n  overflow-y: auto;\n  overscroll-behavior: contain;\n  scrollbar-gutter: stable;\n  box-sizing: border-box;\n}\n\n.title {\n  font-size: 1.875rem;\n  font-weight: 700;\n  color: #111827;\n  margin-bottom: 24px;\n  padding-right: 40px;\n}\n\n.infoBanner {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  background-color: #eff6ff;\n  border-radius: 8px;\n  padding: 16px;\n  margin-bottom: 24px;\n\n  p {\n    font-size: 14px;\n    color: #374151;\n    margin: 0;\n    line-height: 1.4;\n  }\n}\n\n.infoIcon {\n  color: #2563eb;\n  font-size: 20px !important;\n  flex-shrink: 0;\n}\n\n.tabToggle {\n  display: flex;\n  gap: 8px;\n  margin-bottom: 24px;\n}\n\n.tabBtn {\n  flex: 1;\n  padding: 12px 24px;\n  border-radius: 50px;\n  font-size: 14px;\n  font-weight: 600;\n  border: none;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  background-color: #f3f4f6;\n  color: #374151;\n\n  &:hover {\n    background-color: #e5e7eb;\n  }\n\n  &.active {\n    background-color: #111827;\n    color: #ffffff;\n  }\n}\n\n.socialButtons {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  margin-bottom: 24px;\n}\n\n.googleBtn,\n.facebookBtn,\n.appleBtn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  width: 100%;\n  height: 48px;\n  border-radius: 50px;\n  font-size: 14px;\n  font-weight: 600;\n  border: none;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n}\n\n.googleBtn {\n  background-color: #4285f4;\n  color: #ffffff;\n\n  &:hover {\n    background-color: #3367d6;\n  }\n}\n\n.facebookBtn {\n  background-color: #1877f2;\n  color: #ffffff;\n\n  &:hover {\n    background-color: #166fe5;\n  }\n}\n\n.appleBtn {\n  background-color: #000000;\n  color: #ffffff;\n\n  &:hover {\n    background-color: #1a1a1a;\n  }\n}\n\n.socialIcon {\n  width: 20px;\n  height: 20px;\n}\n\n.divider {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  margin: 24px 0;\n\n  &::before,\n  &::after {\n    content: '';\n    flex: 1;\n    height: 1px;\n    background-color: #d1d5db;\n  }\n\n  span {\n    font-size: 14px;\n    color: #6b7280;\n  }\n}\n\n.formGroup {\n  margin-bottom: 16px;\n}\n\n.formRow {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 12px;\n\n  .formGroup {\n    margin-bottom: 16px;\n  }\n}\n\n.label {\n  display: block;\n  font-size: 14px;\n  font-weight: 600;\n  color: #111827;\n  margin-bottom: 8px;\n}\n\n.input {\n  width: 100%;\n  height: 48px;\n  padding: 0 16px;\n  border: 1px solid #d1d5db;\n  border-radius: 8px;\n  font-size: 16px;\n  outline: none;\n  transition: border-color 0.2s ease, box-shadow 0.2s ease;\n  box-sizing: border-box;\n\n  &::placeholder {\n    color: #9ca3af;\n  }\n\n  &:focus {\n    border-color: #2563eb;\n    box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);\n  }\n\n  &:disabled {\n    background-color: #f3f4f6;\n    cursor: not-allowed;\n  }\n}\n\n.inputError {\n  border-color: #dc2626;\n\n  &:focus {\n    border-color: #dc2626;\n    box-shadow: 0 0 0 3px rgba(220, 38, 38, 0.1);\n  }\n}\n\n.errorText {\n  display: block;\n  font-size: 12px;\n  color: #dc2626;\n  margin-top: 4px;\n}\n\n.errorBanner {\n  background-color: #fef2f2;\n  border: 1px solid #fecaca;\n  border-radius: 8px;\n  padding: 12px 16px;\n  margin-bottom: 16px;\n  color: #dc2626;\n  font-size: 14px;\n}\n\n.passwordWrapper {\n  position: relative;\n\n  .input {\n    padding-right: 52px;\n  }\n}\n\n.passwordToggle {\n  position: absolute;\n  right: 4px;\n  top: 50%;\n  width: 44px;\n  height: 44px;\n  transform: translateY(-50%);\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 0;\n  color: #6b7280;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  &:hover {\n    color: #374151;\n  }\n\n  &:focus-visible {\n    outline: 2px solid #2563eb;\n    outline-offset: 2px;\n    border-radius: 6px;\n  }\n\n  svg {\n    font-size: 20px;\n  }\n}\n\n.forgotPassword {\n  display: inline-block;\n  font-size: 14px;\n  color: #2563eb;\n  text-decoration: none;\n  margin-bottom: 16px;\n\n  &:hover {\n    text-decoration: underline;\n  }\n}\n\n.primaryBtn {\n  width: 100%;\n  height: 48px;\n  background-color: #2563eb;\n  color: #ffffff;\n  border: none;\n  border-radius: 50px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n  margin-bottom: 16px;\n\n  &:hover {\n    background-color: #1d4ed8;\n  }\n}\n\n.terms {\n  font-size: 12px;\n  color: #4b5563;\n  text-align: center;\n  line-height: 1.5;\n\n  a {\n    color: #2563eb;\n    text-decoration: underline;\n  }\n}\n\n.buttonGroup {\n  display: flex;\n  gap: 8px;\n}\n\n.outlineBtn {\n  flex: 1;\n  height: 48px;\n  background-color: transparent;\n  color: #374151;\n  border: 1px solid #d1d5db;\n  border-radius: 50px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n\n  &:hover {\n    background-color: #f9fafb;\n  }\n}\n\n.outlineBtnFull {\n  width: 100%;\n  height: 48px;\n  background-color: transparent;\n  color: #374151;\n  border: 1px solid #d1d5db;\n  border-radius: 50px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n\n  &:hover {\n    background-color: #f9fafb;\n  }\n}\n\n// Address input styles\n.addressInputWrapper {\n  position: relative;\n}\n\n.addressIcon {\n  position: absolute;\n  left: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n  color: #9ca3af;\n  font-size: 20px !important;\n  z-index: 1;\n  pointer-events: none;\n}\n\n.addressInput {\n  padding-left: 40px !important;\n  padding-right: 40px !important;\n}\n\n.addressSecondary {\n  margin-top: 8px;\n}\n\n.addressLoader {\n  position: absolute;\n  right: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n}\n\n.addressSuggestions {\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 100%;\n  margin-top: 4px;\n  background: #ffffff;\n  border: 1px solid #e5e7eb;\n  border-radius: 12px;\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);\n  z-index: 100;\n  max-height: 200px;\n  overflow-y: auto;\n  list-style: none;\n  padding: 0;\n  margin-bottom: 0;\n}\n\n.addressSuggestionItem {\n  padding: 10px 14px;\n  cursor: pointer;\n  border-bottom: 1px solid #f3f4f6;\n  color: #374151;\n  font-size: 14px;\n  transition: background 0.15s;\n  display: flex;\n  align-items: flex-start;\n\n  &:last-child {\n    border-bottom: none;\n  }\n\n  &:hover {\n    background: #f3f4f6;\n  }\n}\n\n.suggestionContent {\n  display: flex;\n  flex-direction: column;\n}\n\n.suggestionPrimary {\n  font-weight: 700;\n  color: #111827;\n}\n\n.suggestionSecondary {\n  font-size: 13px;\n  color: #6b7280;\n}\n\n.successText {\n  display: block;\n  font-size: 12px;\n  color: #16a34a;\n  margin-top: 4px;\n}\n\n.merchantLink {\n  text-align: center;\n  font-size: 14px;\n  color: #4b5563;\n  margin: 16px 0 0 0;\n\n  a {\n    color: #111827;\n    font-weight: 600;\n    text-decoration: none;\n\n    &:hover {\n      text-decoration: underline;\n    }\n  }\n}\n\n.recaptchaWrap {\n  overflow: hidden;\n}\n\n@media (max-width: 480px) {\n  .overlay {\n    padding: 12px;\n  }\n\n  .modal {\n    max-height: calc(100vh - 24px);\n    max-height: calc(100dvh - 24px);\n    border-radius: 14px;\n    scrollbar-gutter: auto;\n  }\n\n  .content {\n    padding: 24px 18px 20px;\n    max-height: calc(100vh - 24px);\n    max-height: calc(100dvh - 24px);\n    scrollbar-gutter: auto;\n  }\n\n  .closeBtn {\n    top: 10px;\n    right: 10px;\n  }\n\n  .title {\n    font-size: 1.55rem;\n    line-height: 1.15;\n    margin-bottom: 18px;\n  }\n\n  .infoBanner {\n    padding: 12px;\n    margin-bottom: 18px;\n  }\n\n  .tabToggle,\n  .socialButtons {\n    margin-bottom: 18px;\n  }\n\n  .divider {\n    margin: 18px 0;\n  }\n}\n\n@media (max-width: 380px) {\n  .formRow {\n    grid-template-columns: 1fr;\n    gap: 0;\n  }\n\n  .recaptchaWrap > div {\n    width: 108.7%;\n    margin-bottom: -5px;\n    transform: scale(0.92);\n    transform-origin: top left;\n  }\n}\n\n@media (max-width: 340px) {\n  .recaptchaWrap > div {\n    width: 125%;\n    margin-bottom: -15px;\n    transform: scale(0.8);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"overlay": `AuthModal_overlay__WjGWt`,
	"backdrop": `AuthModal_backdrop__nCSzQ`,
	"modal": `AuthModal_modal__2mBhy`,
	"closeBtn": `AuthModal_closeBtn__uDTXq`,
	"content": `AuthModal_content__X960c`,
	"title": `AuthModal_title__EJUoo`,
	"infoBanner": `AuthModal_infoBanner__fpQod`,
	"infoIcon": `AuthModal_infoIcon__T6bX-`,
	"tabToggle": `AuthModal_tabToggle__j5WQ5`,
	"tabBtn": `AuthModal_tabBtn__4KAnq`,
	"active": `AuthModal_active__pvKsS`,
	"socialButtons": `AuthModal_socialButtons__H+Z+e`,
	"googleBtn": `AuthModal_googleBtn__nB42O`,
	"facebookBtn": `AuthModal_facebookBtn__Yy6gY`,
	"appleBtn": `AuthModal_appleBtn__xyVCg`,
	"socialIcon": `AuthModal_socialIcon__lM3Xw`,
	"divider": `AuthModal_divider__98Mac`,
	"formGroup": `AuthModal_formGroup__dHQlU`,
	"formRow": `AuthModal_formRow__iRhqb`,
	"label": `AuthModal_label__1tq0v`,
	"input": `AuthModal_input__pRkh1`,
	"inputError": `AuthModal_inputError__N-670`,
	"errorText": `AuthModal_errorText__yIyXz`,
	"errorBanner": `AuthModal_errorBanner__GttOL`,
	"passwordWrapper": `AuthModal_passwordWrapper__6Fe8g`,
	"passwordToggle": `AuthModal_passwordToggle__4q+vo`,
	"forgotPassword": `AuthModal_forgotPassword__sInqM`,
	"primaryBtn": `AuthModal_primaryBtn__H320r`,
	"terms": `AuthModal_terms__pymqX`,
	"buttonGroup": `AuthModal_buttonGroup__XCfDU`,
	"outlineBtn": `AuthModal_outlineBtn__tpyA1`,
	"outlineBtnFull": `AuthModal_outlineBtnFull__F60Cj`,
	"addressInputWrapper": `AuthModal_addressInputWrapper__YL42y`,
	"addressIcon": `AuthModal_addressIcon__VD1pq`,
	"addressInput": `AuthModal_addressInput__XIpB6`,
	"addressSecondary": `AuthModal_addressSecondary__ejOeN`,
	"addressLoader": `AuthModal_addressLoader__q8U7s`,
	"addressSuggestions": `AuthModal_addressSuggestions__yiwnj`,
	"addressSuggestionItem": `AuthModal_addressSuggestionItem__nobp9`,
	"suggestionContent": `AuthModal_suggestionContent__eIu-r`,
	"suggestionPrimary": `AuthModal_suggestionPrimary__h0l1-`,
	"suggestionSecondary": `AuthModal_suggestionSecondary__Q232s`,
	"successText": `AuthModal_successText__zyovj`,
	"merchantLink": `AuthModal_merchantLink__J4qdO`,
	"recaptchaWrap": `AuthModal_recaptchaWrap__X6Jw1`
};
export default ___CSS_LOADER_EXPORT___;
